import { Component } from '@angular/core';
import { SearchComponent } from '../Components/search.component';

@Component({
    selector: 'articles-list',
    templateUrl: './articles-list.component.html',
    styles: [],
    providers: []
})
export class ArticlesListComponent extends SearchComponent {
}
